import React from "react"
import logo from "../images/tinaba/logo_tinaba_colore_orizzontale.svg"
import { homeUrl } from "../utils/browser-helpers"
import * as s from './css/header-tinaba.module.css'

const HeaderTinaba = ({project}) => {

    const url = homeUrl(project);

    return (
        <div className={`container ${s.container}`}>
            <a href={url}>
                <img src={logo} className={s.logo} alt="Tinaba" />
            </a>
        </div>
    )
}


export default HeaderTinaba
